import Collection   from 'ol/Collection'
//import { toContext } from 'ol/render'
import Feature      from 'ol/Feature'
import Fill         from 'ol/style/Fill'
import Icon         from 'ol/style/Icon'
import Point        from 'ol/geom/Point'
//import Polygon      from 'ol/geom/Polygon'
import Stroke       from 'ol/style/Stroke'
import Style        from 'ol/style/Style'
import Text         from 'ol/style/Text'
import VectorLayer  from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'

import blueMarker   from '../resources/images/marker-blue.png'
import greenMarker  from '../resources/images/marker-green.png'
import redMarker    from '../resources/images/marker-red.png'
import yellowMarker from '../resources/images/marker-yellow.png'

const getMarker = (id, coordinate, label, color) => {
  let feature = new Feature({
        geometry: new Point(coordinate),
        myLabel: label,
        //xOffset: 50,  // could be used to adjust for # of digits in label
        myId: 'markerId'
      });
  feature.setId(id);
  feature.setStyle(getMarkerStyleFunction(color));
  //feature.setStyle(getCrosshairStyle([0,0,0,1]));
  return feature;
}

const getMarkerStyleFunction = (color) => {
  const iconSrc = {
    BLUE:   blueMarker,
    GREEN:  greenMarker,
    RED:    redMarker,
    YELLOW: yellowMarker,
  };

  return (feature, resolution) => {
    return new Style({
      image: new Icon ({
        src: iconSrc[color],
        anchor: [0.5, 1.0],
        scale: 0.10
        //imgSize:[20, 30]
      }),
      text: new Text ({
        text: feature.get('myLabel'),
        offsetY: -19,
        //font: '12px helvetica, sans-serif',
        font: 'bold 12px arial, sans-serif',
        fill: new Fill({
          color: 'black'
        })

        ,stroke: new Stroke({
          color:  'white',
          width: 1
        })

      })
    });
  }
}


class Markers {
  constructor(layerName, projection='EPSG:2264') {
    this.layerName = layerName;

    this.layer = new VectorLayer({
      layerName: this.layerName,
      visible: true,
      //style: markerFeatureStyleFunction,
      source: new VectorSource({
          features: new Collection(),
          projection: projection
      })
    });
    this.layer.printLayer = true;

    this.BLUE =   'BLUE';
    this.GREEN =  'GREEN';
    this.RED =    'RED';
    this.YELLOW = 'YELLOW';

  }

  add(id, coordinate, label, color=this.BLUE) {
    const marker = getMarker(id, coordinate, label, color);
    //console.log(marker);
    //console.log(this.layer.getSource);
    this.layer.getSource().addFeature(marker);
    return marker;
  }

  clear() {
    this.layer.getSource().clear();
  }

  remove(marker) {
    this.layer.getSource().removeFeature(marker);
  }

  removeById(id) {
    const source = this.layer.getSource();
    const marker = source.getFeatureById(id);
    source.removeFeature(marker);
  }
}

export default Markers;
